import React from 'react';
import { cn } from '../../../lib/utils';
import { TaskyLabel } from './TaskyLabel';

export interface TaskyFormGroupProps {
  label?: React.ReactNode;
  required?: boolean;
  helper?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

export const TaskyFormGroup: React.FC<TaskyFormGroupProps> = ({
  label,
  required,
  helper,
  error,
  htmlFor,
  className,
  children,
}) => (
  <div className={cn('space-y-1.5', className)}>
    {label && (
      <TaskyLabel htmlFor={htmlFor} required={required} error={Boolean(error)}>
        {label}
      </TaskyLabel>
    )}
    {children}
    {helper && !error && <p className="text-xs text-gray-500">{helper}</p>}
    {error && <p className="text-xs text-destructive">{error}</p>}
  </div>
);
